export default "__VITE_ASSET__CWFAY_fr__"